import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../shared/context/auth-context";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import BacktestOverview from "../components/BacktestOverview";
import InstrumentList from "../components/InstrumentList";
import "./Trades.css";

// /portfolio, for admins and portfolio managers (App.js redirects everyone
// else, the /api/dashboard routes require one of the two roles): the backtest
// on top (BacktestOverview loads its own data), then the instruments
const Trades = () => {
  const auth = useContext(AuthContext);
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const [loadedInstruments, setLoadedInstruments] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const load = async () => {
      setIsLoading(true);
      try {
        const response = await fetch("/api/dashboard/instrument_list", {
          headers: { "Content-Type": "application/json", Authorization: "Bearer " + auth.token },
          signal: controller.signal,
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.message || "Failed to fetch the instruments");
        setLoadedInstruments(data);
      } catch (err) {
        if (err.name !== "AbortError") setError(err.message || "An error occurred while fetching data");
      } finally {
        if (!controller.signal.aborted) setIsLoading(false);
      }
    };
    load();
    return () => controller.abort();
  }, [auth.token]);

  // e.g. after an instrument was removed (InstrumentDetails)
  const notice = location.state?.notice;

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={() => setError(null)} />
      {notice && <p className="trades-notice" role="status">{notice}</p>}
      <BacktestOverview />
      {isLoading && (
        <div className="center">
          <LoadingSpinner asOverlay message="LOADING "/>
        </div>
      )}
      {loadedInstruments && (
        <div className="portfolio-instruments">
          <InstrumentList loadedData={loadedInstruments} />
        </div>
      )}
    </React.Fragment>
  );
};

export default Trades;
